import {
    DependenciesPayload,
    OfferDetails,
    OfferType,
    PhaseType,
} from '@sxm-de/dev-kits/web-sdk/types';
import { offerPricing } from './mappers/offer-pricing';
import { getOfferDetailsCall } from './helpers/get-offer-details-call';

export async function getOfferDetails(
    {
        offerId,
    }: {
        offerId: string;
    },
    dependencies: DependenciesPayload,
): Promise<OfferDetails> {
    try {
        const offerDetails = await getOfferDetailsCall(
            { offerId },
            dependencies,
        );
        const priceAndTerm = offerPricing(offerDetails.offer);
        let type: OfferType = 'SelfPay';
        if (
            offerDetails.offer.phases.some(
                ({ type }: { type: PhaseType }) => type === 'Free',
            )
        ) {
            type = 'Trial';
        } else if (
            offerDetails.offer.phases.some(
                ({ type }: { type: PhaseType }) => type === 'Introductory',
            )
        ) {
            type = 'Promo';
        }
        return {
            offer: {
                id: offerId,
                phases: offerDetails.offer.phases,
                priceAndTerm,
                type,
            },
        };
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
